import { Factory, Users, Award, Globe } from 'lucide-react';

const About = () => {
  const values = [
    {
      icon: Factory,
      title: 'Quality Manufacturing',
      description: 'Every furnace is built to exacting standards with premium materials and rigorous testing.',
    },
    {
      icon: Users,
      title: 'Expert Team',
      description: 'Experienced metallurgists and engineers with decades of combined expertise.',
    },
    {
      icon: Award,
      title: 'Proven Track Record',
      description: 'Over 100 successful installations across diverse industries worldwide.',
    },
    {
      icon: Globe,
      title: 'Pan India Reach',
      description: 'Serving clients across continents with local support and international standards.',
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <section className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="inline-block px-4 py-2 bg-orange-500/20 border border-orange-500 rounded-full text-sm font-semibold mb-4">
              About Us
            </div>
            <h1 className="text-4xl lg:text-5xl font-bold mb-4">
              Building Excellence in <span className="gradient-text">Industrial Heat</span>
            </h1>
            <p className="text-xl text-gray-300">
              Since 1989, Arkotherm has been at the forefront of industrial furnace technology,
              delivering precision thermal solutions to manufacturers worldwide.
            </p>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="section-padding bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=600&h=500&fit=crop"
                alt="Arkotherm Factory"
                className="rounded-2xl shadow-2xl"
              />
            </div>
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Our <span className="gradient-text">Story</span>
              </h2>
              <div className="space-y-4 text-lg text-gray-700 leading-relaxed">
                <p>
                    We would like to introduce ourselves as the pioneer manufacturers of Heat Treatment Furnaces and its allied products since 1960. Our range includes furnaces for Hardening, Tempering, Normalizing, Annealing and Melting of non ferrous metals etc.


                </p>
                <p>
                    We cater to various industries as Cycle, Auto parts, Bearings, Valves, Gears, Tractor parts, Fasteners , Hand Tools etc etc.


                </p>
                <p>
                    Quality, being our forte has kept us in the business since 1960. Our products are made with utmost care and using quality raw material with years of experience in the field of heat treatment furnaces & spares.

                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section-padding bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Our <span className="gradient-text">Values</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              The principles that guide every project and relationship.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <div key={index} className="bg-white rounded-xl p-6 shadow-lg hover-lift">
                  <Icon className="text-orange-500 mb-4" size={40} />
                  <h4 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h4>
                  <p className="text-gray-700 leading-relaxed">{value.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="section-padding dark-gradient text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 text-center">
            {[
              { value: '65+', label: 'Years Experience' },
              { value: '1000+', label: 'Installations' },
              { value: '20+', label: 'Skilled Team' },
              { value: '15+', label: 'Cities Served' },
            ].map((stat, index) => (
              <div key={index}>
                <div className="text-5xl font-bold gradient-text mb-2">{stat.value}</div>
                <div className="text-gray-300 text-lg">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding bg-gradient-to-r from-orange-500 to-yellow-500">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-white mb-4">Join our growing list of satisfied clients</h2>
          <p className="text-xl text-white/90 mb-8">
            Experience the Arkotherm difference — precision, reliability, and support you can count on.
          </p>
          <a
            href="/contact"
            className="inline-block px-8 py-4 bg-white text-orange-600 font-bold rounded-full hover:shadow-xl transition-all duration-300"
            data-testid="about-cta-btn"
          >
            Work With Us
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;